import React from 'react';
import { Request } from '../../services/requestsService';
import FlightInfoSection from './FlightInfoSection';
import CarInfoSection from './CarInfoSection';
import TaskInfoSection from './TaskInfoSection';
import FuelTracking from './FuelTracking';

interface TaskDetailSectionsProps {
  task: Request;
  carDetails: any;
  actionLoading: boolean;
}

const TaskDetailSections: React.FC<TaskDetailSectionsProps> = ({
  task,
  carDetails,
  actionLoading
}) => {
  return (
    <>
      <div className="task-detail-description">
        <h2>Описание</h2>
        <p>{task.description}</p>
      </div>

      <div className="task-detail-sections">
        <FlightInfoSection task={task} />
        
        <CarInfoSection
          task={task}
          carDetails={carDetails}
          actionLoading={actionLoading}
        />
        
        {carDetails && (
          <FuelTracking
            carId={carDetails.id}
            carName={carDetails.name}
            imei={carDetails.imei}
          />
        )}
        
        <TaskInfoSection task={task} />
      </div>
    </>
  );
};

export default TaskDetailSections; 